import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from '../../shared/message.service';
import { GeneralExerciseComponent } from '../../General/g-exercise.component';
import { TopicService } from '../topic.service';
import { SelfcorrectingService } from '../selfcorrecting.service';

@Component({
  selector: 'app-open-question',
  templateUrl: './open-question.component.html',
  styleUrls: ['./open-question.component.css']
})
export class OpenQuestionComponent extends GeneralExerciseComponent {

  public solution = "";
  public question: string;
  code: string;
  showCode: string;
  useTable: boolean = false;
  x: string[] = [];

  constructor(protected activatedRoute: ActivatedRoute, protected topicService: TopicService, protected messageService: MessageService, protected selfcorrectingService: SelfcorrectingService) {
    super(activatedRoute, topicService, messageService);
  }

  setTypeSpecificsFromConfiguration() {
    this.solution = "";
    if (this.configuration.typespecifics.question != undefined) {
      this.question = this.configuration.typespecifics.question;
      this.code = this.configuration.typespecifics.code;
      if (this.question == 'twoErrorsEAN' || this.question == 'twoErrorsISBN') {
        this.useTable = this.configuration.typespecifics.useTable;
        this.x = this.code.split("");
        this.recompute();
      }

      this.computeShowCode();
    }
  }

  setTypeSpecificsFromState() {
    if (this.state.typespecific.solution != undefined) {
      this.solution = this.state.typespecific.solution;
      if (this.question == 'twoErrorsEAN' || this.question == 'twoErrorsISBN') {
        this.x = this.solution.split("");
        this.recompute();
      }
    }
  }

  computeState() {
    this.state.typespecific.solution = this.solution;
  }

  /** checks, whether the solution is correct and sends messages */
  checkSolution() {
    let sol = this.solution.replace(/[^0-9Xx]/gi, "").toUpperCase();
    if (this.question != undefined && this.question != "") {
      let correct = false;
      if (this.question == "checkBitEAN") {
        console.log(this.selfcorrectingService.eanCheckBit(this.code));
        if (sol == this.selfcorrectingService.eanCheckBit(this.code)) {
          correct = true;
        }
      } else if (this.question == "twoErrorsISBN") {
        console.log(this.selfcorrectingService.isbnCheckBit(sol.substr(0, 9)))
        console.log(this.selfcorrectingService.isbnCheckBit(this.code))
        if (sol.length == 10 && this.selfcorrectingService.isbnCheckBit(sol.substr(0, 9)) == this.selfcorrectingService.isbnCheckBit(this.code)) {
          correct = true;
        }
      }
      else if (this.question == 'checkBitISBN') {
        if (sol == this.selfcorrectingService.isbnCheckBit(this.code)) {
          correct = true;
        }
      } else {
        console.log(this.selfcorrectingService.eanCheckBit(sol.substr(0, 9)))
        console.log(this.selfcorrectingService.eanCheckBit(this.code))

        if (sol.length == 13 && this.selfcorrectingService.eanCheckBit(sol.substr(0, 12)) == this.selfcorrectingService.eanCheckBit(this.code)) {
          correct = true;
        }
      }
      if (correct) {
        this.messageService.addAlertWithTimeout(this.get("correct"), "success", 3000);
        this.solved = true;
        this.state.solved = true;
        this.saveState();
      } else {
        this.messageService.addAlertWithTimeout(this.get("wrongAnswer"), "danger", 10000);
      }
    } else {
      if (this.solution.length > 0) {
        this.solved = true;
        this.state.solved = true;
        this.saveState();
      }
    }
  }

  /** evaluates the current state of the exercise 
     * @returns {number} - returns the total number of points 
    */
  evaluate(): number[] {
    let result = 1;
    if (this.question != "") {
      result = 0;
      let sol = this.solution.replace(/[^0-9Xx]/gi, "").toUpperCase();
      if (this.question != undefined && this.question != "") {
        let correct = false;
        if (this.question == "checkBitEAN") {
          if (sol == this.selfcorrectingService.eanCheckBit(this.code)) {
            result = 1;
          }
        } else if (this.question == "twoErrorsISBN") {
          if (sol.length == 10 && this.selfcorrectingService.isbnCheckBit(sol.substr(0, 9)) == this.selfcorrectingService.isbnCheckBit(this.code)) {
            result = 1;
          }
        }
        else if (this.question == 'checkBitISBN') {
          if (sol == this.selfcorrectingService.isbnCheckBit(this.code)) {
            result = 1;
          }
          if (sol == "10" && this.selfcorrectingService.isbnCheckBit(this.code) == "X") {
            result = 0.5;
          }
        } else {

          if (sol.length == 13 && this.selfcorrectingService.eanCheckBit(sol.substr(0, 12)) == this.selfcorrectingService.eanCheckBit(this.code)) {
            result = 1;
          }
        }
      }
    }
    return [result, 1];
  }

  /** returns the expected solution based on the typespecific parts of the question */
  expectedSolution(): any {
    if (this.question == "twoErrorsEAN") {
      this.showCode = this.code.concat(this.selfcorrectingService.eanCheckBit(this.code));
    } else if (this.question == "twoErrorsISBN") {
      this.showCode = this.code.substr(0, 1).concat("-", this.code.substr(1, 3), "-", this.code.substr(4, 5), "-", this.selfcorrectingService.isbnCheckBit(this.code));
    }
    else if (this.question == 'checkBitISBN') {
      this.showCode = this.code.substr(0, 1).concat("-", this.code.substr(1, 3), "-", this.code.substr(4, 5), "-", "?");
    } else {
      this.showCode = this.code.concat("?");
    }
  }

  computeShowCode() {
    if (this.question == "twoErrorsEAN") {
      this.showCode = this.code.concat(this.selfcorrectingService.eanCheckBit(this.code));
    } else if (this.question == "twoErrorsISBN") {
      this.showCode = this.code.substr(0, 1).concat("-", this.code.substr(1, 3), "-", this.code.substr(4, 5), "-", this.selfcorrectingService.isbnCheckBit(this.code));
    }
    else if (this.question == 'checkBitISBN') {
      this.showCode = this.code.substr(0, 1).concat("-", this.code.substr(1, 3), "-", this.code.substr(4, 5), "-", "?");
    } else {
      this.showCode = this.code.concat("?");
    }
  }

  /** recompute the control bit on change */
  recompute() {
    let code = this.x.join("");
    if (this.question == "twoErrorsEAN" || this.question == "twoErrorsEAN") {
      this.x[12] = this.selfcorrectingService.eanCheckBit(code);
    } else {
      this.x[9] = this.selfcorrectingService.isbnCheckBit(code);
    }
    if (this.useTable) {
      this.solution = this.x.join("");
    }
  }
}
